<div class="layout-footer">
    <img
        width="60"
            src="assets/demo/images/wise-logo.png"
            alt="diamond-layout"
        />
    
    <span class="footer-copyright">&#169; Wise - 2023</span>
</div>
